import luhn from 'fast-luhn';

export function luhnValidator(messageKey?: string) {
  return (value: string) => {
    return !luhn(value) && (messageKey || 'VoLuhnValidError');
  };
}
